// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"a6bd938d","770":"917f8cc1","1870":"47747808","2170":"b9612411","2181":"dbba44b9","7963":"b9612411","8065":"caad0708","8438":"85342249"}[chunkId] + ".chunk.css";
};